<div>
  <div class="add-title">
    <h2 class="primary" i18n="@@Add Facility Inventory Product">Add Facility Inventory Product</h2>
  </div>
  <div>
    <form [formGroup]="addForm" (change)="formChanged()">
      <mat-grid-list cols="2" [cols]="breakpoint" rowHeight="72px" (window:resize)="onResize($event)">
        <mat-grid-tile *ngIf="startupService.selectedRole !== 'facility'">
          <div class="text-inside">
            <mat-form-field class="full-width">
              <mat-label i18n="@@Facility">Facility</mat-label>
              <mat-select formControlName="printnode_ID" required>
                <mat-option value="1" i18n='@@Phoneix, AZ'>Phoneix, AZ</mat-option>
                <mat-option value="7" i18n='@@Houston, TX' selected='selected'>Houston, TX</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field class="full-width">
              <mat-label i18n="@@BookId">Book Id</mat-label>
              <input matInput id="bookId" type="number" min="100"  max="1000000" formControlName="bookId">
            </mat-form-field>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="text-inside">
            <button mat-icon-button color="primary" [disabled]="!addForm.controls.bookId.value || addForm.controls.bookId.value < 100" (click)="lookupProductFromBookId()" i18n-title="@@Lookup Product From BookId" title="Lookup Product From BookId"><mat-icon>search</mat-icon></button>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field class="full-width">
              <mat-label i18n="@@location">Location</mat-label>
              <input matInput id="location" type="text" formControlName="location">
            </mat-form-field>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field class="full-width">
              <mat-label i18n="@@Shelf">Shelf</mat-label>
              <input matInput id="shelf" type="text" formControlName="shelf">
            </mat-form-field>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field class="full-width">
              <mat-label i18n="@@Inventory Management Type">Inventory Management Type</mat-label>
              <mat-select formControlName="inventoryManagementType" required>
                <mat-option value="CUSTOMER" i18n='@@Customer'>Customer</mat-option>
                <mat-option value="LEVEL" i18n='@@Level_' selected='selected'>Level</mat-option>
                <mat-option value="ADHOC" i18n='@@Ad Hoc'>Ad Hoc</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field class="full-width">
              <mat-label i18n="@@Reorder Quantity">Reorder Quantity</mat-label>
              <input matInput id="reorderQuantity" type="number" min="0"  max="1500" formControlName="reorderQuantity">
            </mat-form-field>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field class="full-width">
              <mat-label i18n="@@Reorder Level">Reorder Level</mat-label>
              <input matInput id="reorderLevel" type="number" min="0"  max="1500" formControlName="reorderLevel">
            </mat-form-field>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field class="full-width">
              <mat-label i18n="@@Case Quantity">Case Quantity</mat-label>
              <input matInput id="caseQuantity" type="number" min="0"  max="1500" formControlName="caseQuantity">
            </mat-form-field>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field class="full-width">
              <mat-label i18n="@@Initial Quantity">Initial Quantity</mat-label>
              <input matInput id="initialQuantity" type="number" min="0"  max="1500" formControlName="initialQuantity">
            </mat-form-field>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
      <div>
        <p style="color: lightgrey" *ngIf="product"><span i18n="@@Product Title">Product Title</span>: {{product.title}}</p>
        <p *ngIf="message">{{message}}</p>
        <p style="color: red" *ngIf="errorMessage">{{errorMessage}}</p>
        <p style="color: red" *ngIf="addFailed" i18n="@@The inventory item could not be added.">The inventory item could not be added.</p>
      </div>
      <div class="btn-sec">
        <span *ngIf="(addForm.invalid || !product) && getAddButtonBlockers()"
              style="display: block; margin-bottom: 6px; color: #888; font-size: smaller;">
          <ng-container i18n="@@Required to enable">Required to enable</ng-container>:
          {{getAddButtonBlockers()}}
        </span>
        <button mat-raised-button type="button" class="Discard-btn" mat-dialog-close="" i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
        <button mat-raised-button type="submit" color="primary" class="Update-btn"
                [disabled]="addForm.invalid || !product || saving"
                [title]="(addForm.invalid || !product) ? getAddButtonBlockers() : ''"
                (click)="onAdd()"
                i18n="@@Add Inventory Product">Add Inventory Product</button>
      </div>
    </form>
  </div>
</div>
